import React from "react";
import { withStyles } from "material-ui/styles";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classnames from "classnames";
import styles from "./styles";
import Toolbar from "./toolbar/";
import Title from "../ui/title";
import Content from "../ui/content";
import Back from "../ui/back";
import NewDeviceRma from "./rma";

import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Icon from "material-ui/Icon";
import Tabs, { Tab } from "material-ui/Tabs";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";

import ConfirmDialog from "../common/dialog/confirm";
import TestsRowLink from "../table/cells/testsRowLink";

import { dateTimeFormatter, dateFormatter } from "../../common/utils";
import Button from "material-ui/Button/index";
import { createDeviceRma } from "../../redux/actions";
import DeviceLocationModal from "../device-location-modal";

class Device extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLockDeviceModal: false,
      showDeviceStolenModal: false,
      showDeviceStolenConfirmModal: false,
      showDeviceUnStolenModal: false,
      rmaModal: false,
      showDeviceLocationModal: false,
      showDeviceResetPinModal: false,
      detailTab: 0,
    };
  }

  componentWillMount() {
    const { deviceId, deviceInfo, adapterAssetList, hasLrpFreeFeatures } = this.props;
    deviceInfo(deviceId);
    if (hasLrpFreeFeatures) {
      adapterAssetList();
    }
  }

  componentDidUpdate(prevProps) {
    const { deviceId, deviceInfo, adapterAssetList, hasLrpFreeFeatures } = this.props;

    if (hasLrpFreeFeatures && !prevProps.hasLrpFreeFeatures) {
      adapterAssetList();
    }

    if (prevProps.deviceId !== deviceId) {
      deviceInfo(deviceId);
      if (hasLrpFreeFeatures) {
        adapterAssetList();
      }
    }
  }

  toggleResetPin = () => {
    this.setState({
      showDeviceResetPinModal: !this.state.showDeviceResetPinModal
    });
  };

  hideDeviceResetPinModal = () => {
    this.setState({
      showDeviceResetPinModal: false
    });
  };

  resetDevicePin = () => {
    const { deviceId, resetDevicePin } = this.props;
    resetDevicePin(deviceId);
    this.setState({
      showDeviceResetPinModal: false
    });
  };

  toggleStolen = () => {
    this.setState({
      showDeviceStolenModal: !this.state.showDeviceStolenModal
    });
  };

  hideDeviceStolenModal = () => {
    this.setState({
      showDeviceStolenConfirmModal: false,
      showDeviceStolenModal: false
    });
  };

  hideDeviceStolenConfirmModal = () => {
    this.setState({
      showDeviceStolenConfirmModal: false,
      showDeviceStolenModal: false
    });
  };

  toggleLock = () => {
    this.setState({
      showLockDeviceModal: !this.state.showLockDeviceModal
    });
  };

  showDeviceStolenConfirmModal = () => {
    this.setState({
      showDeviceStolenModal: false,
      showDeviceStolenConfirmModal: true
    });
  };
  updateDeviceStolenStatus = () => {
    const { deviceId, updateDeviceStolenStatus, device } = this.props;
    updateDeviceStolenStatus(deviceId, device.isstolen);
    this.setState({
      showDeviceStolenConfirmModal: false,
      showDeviceStolenModal: false,
      showLockDeviceModal: false
    });
  };

  updateDeviceLockStatus = () => {
    const { deviceId, updateDeviceLockStatus, device } = this.props;
    updateDeviceLockStatus(deviceId, device.islocked);
    this.setState({
      showDeviceStolenConfirmModal: false,
      showDeviceStolenModal: false,
      showLockDeviceModal: false
    });
  };

  openRmaModal = () => {
    this.setState({ rmaModal: true });
  }

  closeRmaModal() {
    this.setState({ rmaModal: false });
  }

  onRmaModalSubmit(model) {
    const { deviceId, createDeviceRma } = this.props;
    createDeviceRma(deviceId, model);
    this.setState({ rmaModal: false });
  }

  setDeviceLocationModalOpen(isOpen) {
    this.setState({ showDeviceLocationModal: isOpen });
  }

  openDeviceLocationModal() {
    const { device } = this.props;
    if (device.latitude && device.longitude) {
      this.setDeviceLocationModalOpen(true);
    }
  }

  handleDetailTabChange = (event, detailTab) => {
    this.setState({ detailTab });
  };

  getLinkedAdapters = device => {
    const rows = this.props.adapterAssets && this.props.adapterAssets.data
      ? this.props.adapterAssets.data
      : [];
    const detailDeviceId = device && (device.id || this.props.deviceId);
    const normalizedDetailDeviceId =
      detailDeviceId !== null && typeof detailDeviceId !== "undefined"
        ? String(detailDeviceId)
        : null;
    const normalizedDeviceSerial =
      device && device.deviceserialno ? String(device.deviceserialno) : null;

    return rows.filter(row => {
      const normalizedLinkedDeviceId =
        row.linkeddeviceid !== null && typeof row.linkeddeviceid !== "undefined"
          ? String(row.linkeddeviceid)
          : null;
      const normalizedLinkedDeviceSerial =
        row.linkeddeviceserialno ? String(row.linkeddeviceserialno) : null;

      if (normalizedDetailDeviceId && normalizedLinkedDeviceId) {
        return normalizedLinkedDeviceId === normalizedDetailDeviceId;
      }

      if (normalizedDeviceSerial && normalizedLinkedDeviceSerial) {
        return normalizedLinkedDeviceSerial === normalizedDeviceSerial;
      }

      return false;
    });
  };

  renderLicensesTab = device => {
    const { classes, translate } = this.props;
    const licenses = Array.isArray(device.devicelicenses) ? device.devicelicenses : [];

    if (!licenses.length) {
      return (
        <Typography type="body1" className={classes.detailEmptyState}>
          {translate("device_details_no_licenses")}
        </Typography>
      );
    }

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>
              {translate("device_details_license_number")}
            </TableCell>
            <TableCell className={classes.tableHeader}>
              {translate("device_details_license_description")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {licenses.map((license, index) => (
            <TableRow key={`${license.licenseno || "license"}-${index}`}>
              <TableCell>{license.licenseno}</TableCell>
              <TableCell>{license.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  renderLinkedAdaptersTab = device => {
    const { classes, adapterAssets, translate } = this.props;
    const linkedAdapters = this.getLinkedAdapters(device);

    if (adapterAssets === null) {
      return (
        <Typography type="body1" className={classes.detailEmptyState}>
          {translate('adapter_linked_adapters_loading')}
        </Typography>
      );
    }

    if (!linkedAdapters.length) {
      return (
        <Typography type="body1" className={classes.detailEmptyState}>
          {translate('adapter_no_linked_adapters')}
        </Typography>
      );
    }

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>{translate('adapter_serial')}</TableCell>
            <TableCell className={classes.tableHeader}>{translate('adapter_type')}</TableCell>
            <TableCell className={classes.tableHeader}>{translate('adapter_last_result')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {linkedAdapters.map(adapter => (
            <TableRow key={adapter.adapterserialno}>
              <TableCell>
                <TestsRowLink
                  title={adapter.adapterserialno}
                  link={`/adapter/${encodeURIComponent(adapter.adapterserialno)}?from=devices`}
                />
              </TableCell>
              <TableCell>{adapter.adaptertypename || "-"}</TableCell>
              <TableCell>
                {adapter.lastresultdatetime ? dateTimeFormatter(adapter.lastresultdatetime) : "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  render() {
    const { translate, device, classes, impersonating, softwareUpdate, resetPinForDevices, hasLrpFreeFeatures } = this.props;
    const { rmaModal, detailTab } = this.state;

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }
    const pageShellStyle = {
      paddingTop: margintop,
      boxSizing: "border-box",
      height: "100vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column"
    };

    if (device) {
      let deviceStolenText = device.isstolen
        ? translate("device_unstolen_text")
        : translate("device_stolen_text");
      let deviceStolenConfirmText = device.isstolen
        ? ""
        : translate("device_stolen_confirm_text");
      let deviceLockText = translate(
        device.islocked
          ? "device_unlock_confirm_text"
          : "device_lock_confirm_text"
      );

      const $rmaModal = rmaModal ? (
        <NewDeviceRma
          device={device}
          close={() => this.closeRmaModal()}
          translate={translate}
          submit={(model) => this.onRmaModalSubmit(model)}
        />
      ) : null;

      return (
        <div style={pageShellStyle}>
          <Title
            back={
              <Back link={this.props.backLink || "/devices"} title={translate("general_devices")} />
            }
            title={translate("general_device")}
            toolbar={
              <Toolbar
                translate={translate}
                device={device}
                resetPinForDevices={resetPinForDevices}
                toggleResetPin={() => this.toggleResetPin()}
                toggleStolen={() => this.toggleStolen()}
                toggleLock={() => this.toggleLock()}
                openRmaModal={hasLrpFreeFeatures ? () => this.openRmaModal() : null}
              />
            }
          />
          {device.isstolen && (
            <Paper className={classes.error} elevation={0}>
              <Typography type="h2" component="h2" color="secondary">
                {translate("device_registered_stolen")}
              </Typography>
            </Paper>
          )}
          <Content translate={translate} fillHeight scrollable>
            <Grid container spacing={24}>
              <Grid item xs={4}>
                <Paper className={classnames(classes.paper, classes.infotile)}>
                  <Grid container spacing={0}>
                    <Grid item xs={10}>
                      <Typography type="button" className={classes.text}>
                        {translate("device_details_device_id")}
                      </Typography>
                      <Typography
                        type="heading"
                        className={classnames(classes.text, classes.heading)}
                      >
                        {device.deviceserialno}
                      </Typography>
                      <Typography type="subheading" color="error">
                        {device.islocked
                          ? translate("device_locked_status")
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <React.Fragment>
                        <Icon className={classes.tileIcon}>smartphone</Icon>
                      </React.Fragment>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper className={classnames(classes.paper, classes.infotile)}>
                  <Grid container spacing={0}>
                    <Grid item xs={10}>
                      <Typography type="button" className={classes.text}>
                        {translate("device_details_last_online")}
                      </Typography>
                      <Typography
                        type="heading"
                        className={classnames(classes.text, classes.heading)}
                      >
                        {device.lastonline
                          ? dateTimeFormatter(device.lastonline)
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <React.Fragment>
                        <Icon className={classes.tileIcon}>access_time</Icon>
                      </React.Fragment>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              {hasLrpFreeFeatures && <Grid item xs={4}>
                <Paper className={classnames(classes.paper, classes.infotile)}>
                  <Grid container spacing={0}>
                    <Grid item xs={10}>
                      <Typography type="button" className={classes.text}>
                        {translate("device_details_location")}
                      </Typography>
                      <Typography
                        type="heading"
                        className={classnames(classes.text, classes.heading)}
                      >
                        {device.latitude && device.longitude
                          ? `${device.latitude} ${device.longitude}`
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <React.Fragment>
                        {this.props.appSettingReducer?.activeFeatures?.some(f => f.featureName === 'geolocation_device_lock') &&
                        <Icon className={classnames(classes.tileIcon, classes.clickableIcon)} onClick={() => this.openDeviceLocationModal()}>location_on</Icon>}
                      </React.Fragment>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>}
              <Grid item xs={4}>
                <Paper className={classnames(classes.paper, classes.infotile)}>
                  <Grid container spacing={0}>
                    <Grid item xs={10}>
                      <Typography type="button" className={classes.text}>
                        {translate("device_details_engineer")}
                      </Typography>
                      <Typography
                        type="heading"
                        className={classnames(classes.text, classes.heading)}
                      >
                        {device.engineer ? device.engineer : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <React.Fragment>
                        <Icon className={classes.tileIcon}>account_circle</Icon>
                      </React.Fragment>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper className={classnames(classes.paper, classes.infotile)}>
                  <Grid container spacing={0}>
                    <Grid item xs={10}>
                      <Typography type="button" className={classes.text}>
                        {translate("device_details_software_version")}
                      </Typography>
                      <Typography
                        type="heading"
                        className={classnames(classes.text, classes.heading)}
                      >
                        {device.softwareversion ? device.softwareversion : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <React.Fragment>
                        <Icon className={classes.tileIcon}>sync</Icon>
                      </React.Fragment>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper className={classnames(classes.paper, classes.infotile)}>
                  <Grid container spacing={0}>
                    <Grid item xs={10}>
                      <Typography type="button" className={classes.text}>
                        {translate("device_details_calibration_due_date")}
                      </Typography>
                      <Typography
                        type="heading"
                        className={classnames(classes.text, classes.heading)}
                      >
                        {device.calibrationdue
                          ? dateTimeFormatter(device.calibrationdue)
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <React.Fragment>
                        <Icon className={classes.tileIcon}>build</Icon>
                      </React.Fragment>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper
                  className={classnames(classes.paper, classes.infotile)}
                >
                  <Grid container spacing={0}>
                    <Grid item xs={10}>
                      <Typography type="button" className={classes.text}>
                        {translate("device_registered")}
                      </Typography>
                      <Typography
                        type="heading"
                        className={classnames(
                          classes.text,
                          classes.heading
                        )}
                      >
                        {device.registered
                          ? translate("back_btn_yes")
                          : translate("back_btn_no")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={24}
              justify="center"
              className={classes.containerMargin}
            >
              <Grid item xs={2}>
                <Paper
                  className={classnames(classes.paper, classes.infotexttile)}
                  elevation={0}
                >
                  <Typography type="heading" className={classes.testsinfotile}>
                    {device.coppertestpass}
                  </Typography>
                  <Typography type="subheading">
                    {translate("device_details_copper_tests")}
                  </Typography>
                  <Typography type="button" className={classes.passsedstatus}>
                    {translate("job_header_passed")}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={2}>
                <Paper
                  className={classnames(classes.paper, classes.infotexttile)}
                  elevation={0}
                >
                  <Typography type="heading" className={classes.testsinfotile}>
                    {device.coppertestfail}
                  </Typography>
                  <Typography type="subheading">
                    {translate("device_details_copper_tests")}
                  </Typography>
                  <Typography type="button" className={classes.failedstatus}>
                    {translate("job_header_failed")}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={2}>
                <Paper
                  className={classnames(classes.paper, classes.infotexttile)}
                  elevation={0}
                >
                  <Typography type="heading" className={classes.testsinfotile}>
                    {device.fibertestpass}
                  </Typography>
                  <Typography type="subheading">
                    {translate("device_details_fiber_tests")}
                  </Typography>
                  <Typography type="button" className={classes.passsedstatus}>
                    {translate("job_header_passed")}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={2}>
                <Paper
                  className={classnames(classes.paper, classes.infotexttile)}
                  elevation={0}
                >
                  <Typography type="heading" className={classes.testsinfotile}>
                    {device.fibertestfail}
                  </Typography>
                  <Typography type="subheading">
                    {translate("device_details_fiber_tests")}
                  </Typography>
                  <Typography type="button" className={classes.failedstatus}>
                    {translate("job_header_failed")}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={2}>
                <Paper
                  className={classnames(classes.paper, classes.infotexttilenoborder)}
                  elevation={0}
                >
                  <Typography type="button">
                    {translate("device_details_total_tests")}
                  </Typography>
                  <Typography type="heading" className={classes.testsinfotile}>
                    {device.totaltest}
                  </Typography>
                  <Typography type="subheading">
                    {translate("device_details_total_tests_run")}
                  </Typography>
                </Paper>
              </Grid>
              {/*device.paytstatus !== null && (
                <Grid item xs={2}>
                  <Paper
                    className={classnames(classes.paper, classes.infotexttile)}
                    elevation={0}
                  >
                    <Typography type="button">
                      {translate("device_details_payt_count")}
                    </Typography>
                    <Typography
                      type="heading"
                      className={classes.testsinfotile}
                    >
                      {device.paytstatus}
                    </Typography>

                    <Typography type="subheading">
                      {translate("device_details_credits_remaining")}
                    </Typography>
                  </Paper>
                </Grid>
              )*/}
            </Grid>
            <Grid container spacing={24} className={classes.detailTabsSection}>
              <Grid item xs={12}>
                <Paper className={classes.detailTabsPaper}>
                  <Tabs
                    value={detailTab}
                    onChange={this.handleDetailTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    className={classes.detailTabsHeader}
                  >
                    <Tab label={translate("devices_licenses")} />
                    {hasLrpFreeFeatures && <Tab label={translate('adapter_linked_adapters')} />}
                  </Tabs>
                  <div className={classes.detailTabContent}>
                    {detailTab === 0 || !hasLrpFreeFeatures
                      ? this.renderLicensesTab(device)
                      : this.renderLinkedAdaptersTab(device)}
                  </div>
                </Paper>
              </Grid>
            </Grid>
            <ConfirmDialog
              open={this.state.showDeviceResetPinModal}
              title={translate("reset_pin")}
              contentText={translate("device_resetpin_request")}
              okText={translate("general_confirm")}
              onOk={this.resetDevicePin}
              cancelText={translate("general_cancel")}
              onCancel={this.hideDeviceResetPinModal}
            />
            <ConfirmDialog
              open={this.state.showDeviceStolenModal}
              title={translate("device_stolen_title")}
              contentText={deviceStolenText}
              okText={
                device.isstolen
                  ? translate("general_confirm")
                  : translate("general_proceed")
              }
              onOk={
                device.isstolen
                  ? this.updateDeviceStolenStatus
                  : this.showDeviceStolenConfirmModal
              }
              cancelText={translate("general_cancel")}
              onCancel={this.hideDeviceStolenModal}
            />
            <ConfirmDialog
              open={this.state.showDeviceStolenConfirmModal}
              title={translate("device_stolen_title")}
              contentText={deviceStolenConfirmText}
              contentSecondaryText={
                device.isstolen ? "" : translate("general_confirmation_help_2")
              }
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.updateDeviceStolenStatus}
              onCancel={this.hideDeviceStolenConfirmModal}
            />
            <ConfirmDialog
              open={this.state.showLockDeviceModal}
              title={translate(
                device.islocked ? "device_unlock_title" : "device_lock_title"
              )}
              contentText={deviceLockText}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.updateDeviceLockStatus}
              onCancel={this.toggleLock}
            />
            <ConfirmDialog
              open={this.state.showDeviceUnStolenModal}
              title={translate("device_unstolen_title")}
              contentText={deviceLockText}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.updateDeviceLockStatus}
              onCancel={this.toggleLock}
            />
            {hasLrpFreeFeatures && this.props.appSettingReducer?.activeFeatures?.some(f => f.featureName === 'geolocation_device_lock') &&
            <DeviceLocationModal translate={translate} device={device}
                                 isOpen={this.state.showDeviceLocationModal}
                                 onClose={() => this.setDeviceLocationModalOpen(false)}/>}
          </Content>
          {$rmaModal}
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  resetPinForDevices: state.appSettingReducer.resetPinForDevices,
  ...state,
});

const mapDispatchToProps = (dispatch, props) => ({
  createDeviceRma: (deviceId, data) => {
    dispatch(createDeviceRma(deviceId, data));
  },
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Device);
